import { configureStore } from '@reduxjs/toolkit';
// import SliceOne from "./SliceOne" // Replace with the actual reducer you create
import genericReducer from './SliceOne'
import alertModalReducer from './alertModalSlice';
import activePathReducer from "./SidebarSlice"
import accountReducer from './AccountInfoSlice'
const store = configureStore({
  reducer: {
    generic: genericReducer,
    alertModal: alertModalReducer, 
    activePath: activePathReducer,
    account:accountReducer
  },
});

export default store;